import React from "react";

const NotFound = () => {
  return (
    <div className="text-center py-16 text-[4rem] font-bold">coming soon</div>
  );
};

export default NotFound;
